import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import AOS from 'aos'
import 'aos/dist/aos.css'

const Home: React.FC = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true })
  }, [])

  return (
    <>
      <div className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="container">
            <div className="hero-text" data-aos="fade-up">
              <h1>Celebrating 50 Years of Faith</h1>
              <p className="hero-subtitle">Christ the King Church: A Legacy of Love, Service, and Community</p>
              <p className="hero-description">Join us as we celebrate five decades of God's faithfulness, community service and spiritual growth. Since 1975, Christ the King Church has been a beacon of hope and love in our community.</p>
              <div className="hero-buttons">
                <Link to="/schedules" className="btn-hero-primary">Our Services & Times</Link>
                <Link to="/about-us" className="btn-hero-secondary">Learn our story →</Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className="welcome-section">
        <div className="container">
          <div className="section-header text-center">
            <h2>Welcome to Christ the King Church</h2>
            <p className="section-subtitle">Where Faith Meets Fellowship</p>
          </div>

          <div className="welcome-grid">
            <div className="welcome-card card" data-aos="fade-up" data-aos-delay="100">
              <h3>Our Mission</h3>
              <p>To proclaim the love of Christ, nurture spiritual growth, serve the community with compassion, and build a fellowship rooted in faith, hope, and unity.</p>
            </div>

            <div className="welcome-card card" data-aos="fade-up" data-aos-delay="200">
              <h3>Our Vision</h3>
              <p>To be a Christ-centered community that reflects God’s love, empowers every generation in faith, and transforms lives through service, worship, and witness.</p>
            </div>

            <div className="welcome-card card" data-aos="fade-up" data-aos-delay="300">
              <h3>Our Values</h3>
              <p>Love, Faith, Community, Service, and Integrity guide everything we do. We believe in the power of prayer, the importance of fellowship, and the call to serve.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="services-section">
        <div className="container">
          <div className="section-header text-center" data-aos="fade-up">
            <h2>Service Times</h2>
            <p className='section-subtitle'>Join us for worship and fellowship</p>
          </div>

          <div className="services-grid">
            <div className="service-card card" data-aos="fade-up" data-aos-delay="100">
              <h3>Divine Service</h3>
              <p>1st & 3rd Sundays</p>
              <p className="service-time">8:00 AM onwards</p>
              <p>Traditional worship service with choir, prayers, and inspirational message.</p>

            </div>

            <div className="service-card card" data-aos="fade-up" data-aos-delay="200">
              <h3>Holy Communion Service</h3>
              <p>2nd & 4th Sundays</p>
              <p className="service-time">8:00 AM onwards</p>
              <p>Holy Communion service with sharing of the Lord’s Supper in remembrance of Christ’s sacrifice.</p>
            </div>

            <div className="service-card card" data-aos="fade-up" data-aos-delay="300">
              <h3>First of Every Month</h3>
              <p>Holy Communion Service</p>
              <p className="service-time">6:30 PM onwards </p>
              <p>Holy Communion service with scripture, prayers, and the sharing of the Lord’s Supper.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="anniversary-section">
        <div className="container">
          <div className="anniversary-content" data-aos="fade-in" data-aos-duration="1500">
            <div className="anniversary-text">
              <h2>50 Years of Faith and Fellowship</h2>
              <p className="anniversary-subtitle">1975 - 2025</p>
              <p>For five decades, Christ the King Church has been a cornerstone of faith in our community. From our humble beginnings to our thriving congregation today, we have witnessed countless blessings, baptisms, weddings, and celebrations of life.</p>
              <p>Our journey has been marked by faithful service, community outreach, and the unwavering love of God that binds us together as one family in Christ.</p>
              <Link to="/history" className="btn btn-primary">Explore Our History</Link>
            </div>

            <div className="anniversary-stats">
              <div className="anniversary-logo">
                <img src="/h1.png" alt="Church Logo" className="logo-img" />
              </div>
            </div>
          </div>
        </div>
      </section>

      <style>{`
        .hero {
          position: relative;
          min-height: 90vh;
          background: url('/Altar.JPG') center/cover;
          display: flex;
          align-items: center;
          overflow: hidden;
        }

        .hero-overlay {
          position: absolute;
          top: 0;
          left: 0;
          bottom: 0;
          right: 0;
          width: 100%;
          background: rgba(30, 42, 74, 0.6);
          z-index: 1;
        }

        // .marquee-wrapper {
        //   display: inline-block;
        //   white-space: nowrap;
        //   animation: marquee 25s linear infinite;
        // }

        @keyframes marquee {
          0% { transform: translateX(100vw); }
          100% { transform: translateX(-100%); }
        }

        .hero-content {
          position: relative;
          z-index: 2;
          width: 100%;
        }

        .hero-text {
          max-width: 550px;
          color: white;
          text-align: left;
        }

        .hero-text h1 {
          font-family: 'Cormorant Garamond', serif;
          font-size: 4rem;
          font-weight: 300;
          color: var(--bg-ivory);
          margin-bottom: 1.5rem;
          line-height: 1.15;
          letter-spacing: 0.04em;
        }

        .hero-subtitle {
          font-size: 1.05rem;
          font-family: 'Inter', sans-serif;
          font-weight: 400;
          color: #f1f1f1;
          margin-bottom: 0.5rem;
        }

        .hero-description {
          font-size: 1.05rem;
          margin-bottom: 2.5rem;
          font-family: 'Inter', sans-serif;
          font-weight: 400;
          color: #f1f1f1;
          line-height: 1.6;
        }

        .hero-buttons {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
          align-items: flex-start;
          margin-top: 2rem;
        }

        .btn-hero-primary {
          display: inline-block;
          background: transparent;
          color: var(--bg-ivory);
          border: 1px solid var(--accent-gold);
          border-radius: 8px;
          padding: 0.75rem 2rem;
          font-weight: 500;
          font-size: 1rem;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .btn-hero-primary:hover {
          background: var(--accent-gold);
          color: var(--primary);
        }

        .btn-hero-secondary {
          color: var(--bg-ivory);
          text-decoration: none;
          font-size: 0.95rem;
          padding: 0;
          display: inline-block;
          transition: all 0.3s ease;
          opacity: 0.9;
        }

        .btn-hero-secondary:hover {
          opacity: 1;
          color: var(--accent-gold);
        }

        .welcome-section {
          padding: 5rem 0 6rem;
          background-color: #F8F5EE;
        }

        .section-header {
          margin-bottom: 3.5rem;
        }

        .section-header h2 {
          font-size: 2.2rem;
          color: #1a2a4f;
          margin-bottom: 0.5rem;
          font-weight: 500;
        }

        .section-header p {
          color: #666;
          font-family: 'DM Sans', sans-serif;
          font-size: 1.1rem;
        }

        .section-subtitle {
          color: #666;
          font-family: 'DM Sans', sans-serif;
          font-size: 1.1rem;
          text-align: center;
          margin-top: 0.5rem;
        }

        .welcome-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 2rem;
        }

        .welcome-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(8px);
          border-radius: 8px;
          padding: 2.5rem;
          box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          position: relative;
          overflow: hidden;
          border: 1px solid rgba(0, 0, 0, 0.05);
        }

        .welcome-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
        }

        .welcome-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 6px;
          background: linear-gradient(90deg, #D4AF37, #9B7E24);
        }

        .welcome-card h3 {
          font-family: 'Inter', sans-serif;
          font-size: 1.1rem;
          letter-spacing: 0.5px;
          color: #222;
          font-weight: 600;
          text-transform: uppercase;
          margin-bottom: 1.25rem;
        }

        .welcome-card p {
          color: #444;
          font-size: 0.95rem;
          line-height: 1.6;
          text-align: left;
        }

        .services-section {
          padding: 5rem 0;
          background-color: #F8F5EE;
        }

        .services-section .section-header h2 {
          font-size: 2.2rem;
          color: #33425b;
          font-weight: 500;
          margin-bottom: 0;
        }

        .services-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 2rem;
        }

        .service-card {
          background: transparent;
          border-radius: 0;
          padding: 1rem 0;
          box-shadow: none;
          text-align: left;
        }

        .service-card:hover {
          transform: none;
          box-shadow: none;
        }

        .service-card h3 {
          font-family: 'Inter', sans-serif;
          font-size: 1rem;
          letter-spacing: 1px;
          color: #333;
          font-weight: 600;
          text-transform: uppercase;
          margin-bottom: 0.5rem;
        }

        .service-card p:nth-of-type(1) {
          font-family: 'DM Sans', sans-serif;
          color: #555;
          margin-top: 0.25rem;
        }

        .service-time {
          font-size: 1.75rem;
          font-weight: 500;
          color: #bfa15f;
          margin-bottom: 1rem;
          border-bottom: 1px solid #dccb99;
          padding-bottom: 0.5rem;
          text-transform: uppercase;
        }

        .service-card p:last-child {
          color: #444;
          font-size: 0.95rem;
          line-height: 1.5;
          text-align: left;
        }

        .anniversary-section {
          padding: 4rem 0;
          background: #efeedd;
          border-top: 1px solid #e1dfc9;
        }

        .anniversary-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 4rem;
        }

        .anniversary-text {
          flex: 1;
        }

        .anniversary-text h2 {
          color: #222;
          font-family: 'Cormorant Garamond', sans-serif;
          font-weight: 900;
          font-size: 2.2rem;
          margin-bottom: 0.25rem;
        }

        .anniversary-subtitle {
          font-family: 'inter', sans-serif;
          font-size: 2.2rem;
          font-weight: 200;
          color: #1e2948;
          margin-bottom: 1.5rem;
        }

        .anniversary-text p {
          color: #333;
          font-size: 0.95rem;
          line-height: 1.6;
          margin-bottom: 1rem;
          text-align: left;
          max-width: 800px;
        }

        .anniversary-text .btn {
          margin-top: 1.5rem;
          display: inline-block;
        }
        
        .anniversary-stats {
          flex: 0 0 300px;
          display: flex;
          justify-content: flex-end;
        }

        .anniversary-logo {
          display: flex;
          align-items: center;
          justify-content: center;
          max-width: 100%;
        }

        .logo-img {
          max-width: 280px;
          width: 100%;
          height: auto;
          object-fit: contain;
          display: block;
        }

        @media (max-width: 992px) {
          .hero-overlay {
            width: 70%;
            clip-path: polygon(0 0, 100% 0, 85% 100%, 0% 100%);
          }
          .welcome-grid, .services-grid {
            grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          }
        }

        @media (max-width: 768px) {
          .hero-overlay {
            width: 100%;
            clip-path: none;
            opacity: 0.85;
          }
          
          .hero-text h1 {
            font-size: 2.5rem;
          }
          
          .hero-buttons {
            flex-direction: column;
            align-items: flex-start;
          }
          
          .welcome-grid, .services-grid {
            grid-template-columns: 1fr;
          }
            
          .anniversary-content {
            flex-direction: column;
            gap: 2rem;
          }
          
          .anniversary-stats {
            justify-content: center;
            flex: auto;
          }
          
          .logo-img {
            max-width: 200px;
          }
        }
      `}</style>
    </>
  )
}

export default Home